import {
  Chip,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader,
  Paper,
  Typography,
} from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

export default function FaqMenuTypeHFString(props) {
  // console.log("Faq Menu Type => List Header Footer String");
  // console.log("props data list header footer string: ", props.faqlistHFStrData);

  let faqlistHFStrData = props.faqlistHFStrData;
  const classes = useStyles();

  return (
    <>
      {faqlistHFStrData.map((data, i) => (
        <>
          <List
            key={i}
            aria-labelledby="nested-list-subheader"
            subheader={<ListSubheader>{data.listHeader}</ListSubheader>}
          >
            {data.listContent.map((items, x) => (
              <ListItem key={x}>
                <ListItemAvatar>
                  <Chip label={x + 1} size="small" />
                </ListItemAvatar>
                <ListItemText primary={items} />
              </ListItem>
            ))}
          </List>
          <Grid item>
            <Paper className={classes.paper}>
              {data.listFooter}
            </Paper>
          </Grid>
        </>
      ))}
    </>
  );
}
